import React, { useState } from 'react';
import { Link } from "react-router-dom";

import { url } from '../../inv';
import { generalS } from '../../strings/general';
import card1  from "../../imgs/card1.jpg";
import card2  from "../../imgs/card2.jpg";

export default function LatestProject({ windowWidth, language, latestEvents }) {

  const layoutHandler = (l) => {
    return( 
      <dvi className={"row"}>
        <div data-aos="fade-up" className={"home-carad-album"}>
          <img className={"home-carad-album-img1-left"} 
            src={`${url}/public/${l.fileNames[0]}`} />
        </div>
        <div className={"home-album-card-contener"}>
          <div className={"home-album-card-title-content"}>
            <p className={"home-card-title"}>{l.data.value.title}</p>
          </div>
          <h1>{l.data.value.subtitle}</h1>
          <p style={{textAlign: "justify"}}>{l.data.value.details[0]}</p>
          <br />
          <div className={"home-card-link-content"}>
            <Link to={`/detail?${l.postId}`} className={"home-card-link"}>
              {generalS.readMore[language]}
            </Link>
          </div>
        </div>
      </dvi>
    );
  }

  return(
    <div className={"home-last-event"}>
    {latestEvents?
      latestEvents.map((l, i) => {
        if (i <= 1) {
          if (windowWidth > 900) {
            if (i == 0) {
              return (
                <dvi className={"row"}>
                  <div className={"home-album-card-contener"}>
                    <div className={"home-album-card-title-content"}>
                      <p className={"home-card-title"}>{l.data.value.title}</p>
                    </div>
                    <h1>{l.data.value.subtitle}</h1>
                    <p style={{textAlign: "justify"}}>{l.data.value.details[0]}</p>
                    <div className={"home-card-link-content"}>
                      <Link to={`/detail?${l.postId}`} className={"home-card-link"}>
                        {generalS.readMore[language]}
                      </Link>
                    </div>
                  </div>
                  <div data-aos="fade-up" className={"home-carad-album"}>
                    <img className={"home-carad-album-img1-left"} 
                      src={`${url}/public/${l.fileNames[0]}`} />
                  </div>
                </dvi>
              )
            } else {
              return(
                <div>
                  {layoutHandler(l)}
                </div>
              )
            }
          } else {
            return(
              <div>
                {layoutHandler(l)}
              </div>
            )
          }
        }
        }): ("")
      }
    </div>
  )
}
